import React from 'react';
import './Account.css';

const Account = ({ user, onNavigate }) => {
  // --- HELPER: Mask Email (johndoe@gmail.com -> jo*****@gmail.com) ---
  const maskEmail = (email) => {
    if (!email) return '******';
    const parts = email.split('@');
    if (parts.length < 2) return email;
    const [name, domain] = parts;
    const maskedName = name.slice(0, 2) + '*'.repeat(Math.max(0, name.length - 2));
    return `${maskedName}@${domain}`;
  };

  /*
  const [loading, setLoading] = useState(false);

  // --- ACTION: Go to Stripe Portal (Manage) ---
  const handleManageSubscription = async () => {
    setLoading(true);
    try {
      const res = await fetch('http://localhost:8000/api/create-portal-session', {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
      else alert("Could not access billing portal. " + (data.message || ""));
    } catch (err) {
      console.error(err);
      alert("Connection error");
    } finally {
      setLoading(false);
    }
  };

  // --- ACTION: Initiate Upgrade (Checkout) ---
  const handleUpgrade = async (cycle) => {
    setLoading(true);
    try {
      const res = await fetch('http://localhost:8000/api/create-checkout-session', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}` 
        },
        body: JSON.stringify({ cycle }) 
      });
      const data = await res.json();
      if (data.url) window.location.href = data.url;
    } catch (err) {
      console.error(err);
      alert("Checkout failed");
    } finally {
      setLoading(false);
    }
  };
  */

  return (
    <div className="account-container">
      <button className="btn-back-account" onClick={() => onNavigate('home')}>
        ← Back to Songs
      </button>
      
      <div className="account-card">
        <div className="account-header">
          <h2>Account Settings</h2>
        </div>

        {/* --- USER INFO SECTION --- */}
        <div className="info-group">
          <label className="info-label">Username</label>
          <div className="info-value">{user.username}</div>
        </div>

        <div className="info-group">
          <label className="info-label">Email</label>
          <div className="info-value">{maskEmail(user.email)}</div>
        </div>

        {/* --- SUBSCRIPTION SECTION --- */}
        <div className="subscription-section">
          <h3 className="sub-title">Subscription Plan</h3>
          
          <div className="plan-status-box">
            <div className="coming-soon-banner">Billing features coming soon</div>
            
            {/* --- CASE 1: FREE USER --- */}
            {user.plan === 'free' && (
              <>
                <div className="plan-header">
                  <span className="plan-name free">Free Plan</span>
                  <span className="status-pill active">Active</span>
                </div>
                <p className="plan-description">
                  Upgrade options are not available yet. <strong>Founder's Premium</strong> billing is coming soon.
                </p>
                
                <div className="upgrade-grid">
                  <button 
                    type="button"
                    disabled
                    className="btn-action btn-monthly btn-coming-soon"
                  >
                    $5 / Month
                    <span className="btn-subtext">Coming soon</span>
                  </button>
                  <button 
                    type="button"
                    disabled
                    className="btn-action btn-yearly btn-coming-soon"
                  >
                    $50 / Year 
                    <span className="btn-subtext">Coming soon</span>
                  </button>
                </div>
              </>
            )}

            {/* --- CASE 2: ORIGINAL (LIFETIME FREE) --- */}
            {user.plan === 'original' && (
              <>
                <div className="plan-header">
                  <span className="plan-name original">Original Member</span>
                  <span className="status-pill lifetime">Lifetime Status</span>
                </div>
                <p className="plan-description">
                  You are one of our first 50 users! You have <strong>Free Lifetime Access</strong> to all premium features.
                  <br/><br/>
                  Thank you for believing in us from the start.
                </p>
              </>
            )}

            {/* --- CASE 3: PREMIUM (PAID) --- */}
            {(user.plan === 'premium' || user.plan === 'founder_premium') && (
              <>
                <div className="plan-header">
                  <span className="plan-name premium">Founder's Premium</span>
                  <span className="status-pill active">Active</span>
                </div>
                <p className="plan-description">
                  Thank you for your support! You are locked in at the Founder's rate.
                </p>
                
                <button 
                  type="button"
                  disabled
                  className="btn-action btn-manage btn-coming-soon"
                >
                  Manage Subscription / Billing
                  <span className="btn-subtext">Coming soon</span>
                </button>
              </>
            )}

          </div>
        </div>
      </div>
    </div>
  );
};

export default Account;
